import { IOccupations } from '../../UI/Components/Occupations/occupations-types';

export const Occupations: IOccupations = {
    1: { FR: 'Sans emploi', KEY: 'occupation.1', EN: 'Jobless' },
    2: { FR: 'Commerçant', KEY: 'occupation.2', EN: 'Trader' },
    3: { FR: 'Employé', KEY: 'occupation.3', EN: 'Employee' },
    4: { FR: 'Fonctionnaire', KEY: 'occupation.4', EN: 'Civil servant' },
    5: { FR: 'Artiste/Liberal', KEY: 'occupation.5', EN: 'Artist/Liberal' },
    6: { FR: 'Personnel Soignant', KEY: 'occupation.6', EN: 'Health staff' },
    7: { FR: 'Personnel Religieux', KEY: 'occupation.7', EN: 'Religious staff' },
    8: { FR: 'Policier/Militaire', KEY: 'occupation.8', EN: 'Police/Military' },
    9: { FR: 'Politicien/Officiels', KEY: 'occupation.9', EN: 'Politicians/Officials' },
    10: { FR: 'Etudiant/Elève', KEY: 'occupation.10', EN: 'Student/Pupil' }
};

export default Occupations;
